<app-expandible-title [title]="'Regra composta'"></app-expandible-title>

<div>
    <span>Nome: </span>
    <span class="font-weight-bold">{{data?.nome}}</span>
</div>

<div>
    <span>Data início vigência: </span>
    <span class="font-weight-bold">{{treatDate(data?.inicioVigencia)}}</span>
</div>

<div>
    <span>Data fim vigência: </span>
    <span class="font-weight-bold">{{treatDate(data?.fimVigencia)}}</span>
</div>
<div>
    <span>Limite inferior: </span>
    <span class="font-weight-bold">{{treatDecimals(data?.parametros?.limites?.limiteInferior)}}</span>
</div>
<div>
    <span>Limite superior: </span>
    <span class="font-weight-bold">{{treatDecimals(data?.parametros?.limites?.limiteSuperior)}}</span>
</div>
<div>
    <span>Regras associadas: </span>
    <ul>
        <li  class="font-weight-bold" *ngFor="let regra of data?.regrasAssociadas">{{regra.nome}}</li>
    </ul>
</div>
